import React from "react";
import { pathMilestone } from "@/lib/letterPolicy";

// School year start → "2027–28".
export const syShort = (y) => `${y}–${String((Number(y) + 1) % 100).padStart(2, "0")}`;

// Next lettering milestone: First Letter, then this school year's Subsequent Letter.
export function letterMilestone(s) {
  if (!s?.policy) return null;
  const pr = s.progress || {};
  if (!s.first_letter_earned) {
    const m = pathMilestone(pr.first, "your First Letter");
    return m && { ...m, done: false };
  }
  // One award per school year: the First Letter year can't also earn a Subsequent Letter.
  if (s.additional_eligible_this_year === false) {
    return { have: 1, need: 1, done: true, label: `Subsequent Letters start next school year (${syShort(s.additional_eligible_from)})` };
  }
  if (s.this_year_awarded) return { have: 1, need: 1, done: true, label: "This year's award earned" };
  const m = pathMilestone(pr.subsequent, "your next award");
  return m ? { ...m, done: false } : { have: 1, need: 1, done: true, label: "First Letter earned" };
}

export default function LetterProgressBar({ status, className = "" }) {
  const m = letterMilestone(status);
  if (!m) return null;
  const pct = Math.min(100, Math.round((m.have / m.need) * 100));
  return (
    <div className={className} data-testid="letter-progress">
      <div className="h-2 overflow-hidden rounded-full bg-violet-100">
        <div className={`h-full rounded-full transition-[width] duration-700 ${m.done ? "bg-emerald-500" : "bg-violet-500"}`} style={{ width: `${pct}%` }} data-testid="letter-progress-fill" />
      </div>
      <p className={`mt-1.5 text-xs ${m.done ? "font-semibold text-emerald-700" : "text-slate-500"}`} data-testid="letter-progress-label">{m.label}</p>
    </div>
  );
}
